import { Flex, Text } from '@skin-seoul/design-system';
const BANNER_TEXT = 'Upto 50% Off across the selection';
const DESKTOP_REPEAT_COUNT = 3;
export const CampaignTextBanner = () => {
  return <Flex width="100%" background="linear-gradient(90deg, #D69C47 0%, #FFD788 100%)" padding="8px 16px" gap={5} alignItems="center" justifyContent="center" borderBottomRadius="12px" data-sentry-element="Flex" data-sentry-component="CampaignTextBanner" data-sentry-source-file="CampaignTextBanner.tsx">
      <Text textStyle="paragraph.large" fontWeight="regular" color="generic.100" textAlign="center" display={{
      base: 'block',
      desktop: 'none'
    }} data-sentry-element="Text" data-sentry-source-file="CampaignTextBanner.tsx">
        {BANNER_TEXT}
      </Text>

      <Flex display={{
      base: 'none',
      desktop: 'flex'
    }} gap={5} alignItems="center" justifyContent="center" width="100%" data-sentry-element="Flex" data-sentry-source-file="CampaignTextBanner.tsx">
        {Array.from({
        length: DESKTOP_REPEAT_COUNT
      }).map((_, index) => <Text key={index} textStyle="paragraph.large" fontWeight="regular" color="generic.100" textAlign="center">
            {BANNER_TEXT}
          </Text>)}
      </Flex>
    </Flex>;
};